import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 1.01L6 1v5h2V5h10v14H8v-1H6v5h14V1.01zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
}), 'AddToHomeScreenSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddToHomeScreenSharp.js
// module id = 1914
// module chunks = 2